<template>
  <div class="department">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>

    <!--内容-->
    <div class="department-content">
      <el-row type="flex" :gutter="10">
        <el-col :span="6">
          <el-card shadow="hover" class="box-card">
            <div slot="header" class="clearfix">
              <span>部门列表</span>
              <span
                class="i-icon"
                v-bind:style="{
                  display: userInfo.userInfo.adminFlag == 1 ? 'inline-block' : 'none',
                }"
              >
                <template v-for="(item, i) in menuButtonList">
                  <svg-icon
                    class="icon-img"
                    style="font-size: 16px; padding-left: 10px"
                    :key="i"
                    v-if="item.type == '0'"
                    :class="item.attributes.buttonStyle"
                    :title="item.label"
                    @click="chooseClick(item.attributes.buttonUrl, item)"
                    :icon-class="item.attributes.buttonStyle"
                  />
                  <!--<i-->
                  <!--  :key="i"-->
                  <!--  v-if="item.type == '0'"-->
                  <!--  :class="item.attributes.buttonStyle"-->
                  <!--  :title="item.label"-->
                  <!--  @click="chooseClick(item.attributes.buttonUrl,item)"-->
                  <!--&gt;</i>-->
                </template>
              </span>
            </div>
            <!-- <el-input
              :placeholder="$t('department.search.departmentNamePlaceholder')"
              v-model="filterText"
            ></el-input>-->
            <el-tree
              class="company-tree"
              :data="data"
              :props="defaultProps"
              :default-expand-all="false"
              highlight-current
              node-key="id"
              :expand-on-click-node="false"
              :filter-node-method="filterNode"
              @node-click="handleNodeClick"
              ref="tree"
              v-bind:style="{ height: heightTree, 'overflow-y': 'auto' }"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span
                  :style="{ color: data.attributes.currentStatus == '1' ? '#ccc' : '#606266' }"
                  >{{ node.label }}</span
                >
              </span>
            </el-tree>
          </el-card>
        </el-col>
        <el-col :span="18">
          <!--管理员-->
          <div v-if="userInfo.userInfo.adminFlag == 1">
            <el-tabs type="card" v-model="activeName" class="common-tab">
              <el-tab-pane :label="firstLabel" name="first">
                <!--查看详情-->
                <div class="detail" v-if="!edit">
                  <companyDetail
                    v-if="detail.type == 'company'"
                    :detail="detail"
                    :tableData="tableData"
                    :receiptClaimModeList="receiptClaimModeList"
                    ref="companyDetail"
                  ></companyDetail>
                  <controlRangeDetail
                    v-else-if="detail.type == 'controlArea'"
                    :detail="detail"
                    :tableData="tableData"
                    ref="controlRangeDetail"
                  ></controlRangeDetail>
                  <departmentDetail
                    v-else
                    :detail="detail"
                    :tableData="tableData"
                    :unitData="unitData"
                    :receiptClaimModeList="receiptClaimModeList"
                    ref="departmentDetail"
                  ></departmentDetail>
                </div>
                <!--编辑-->
                <div class="detail" v-else>
                  <editCompany
                    v-if="detail.type == 'company'"
                    :detail="detail"
                    :tableData="tableData"
                    @getData="getData"
                    :receiptClaimModeList="receiptClaimModeList"
                    @setLoading="setLoading"
                    ref="editCompany"
                  ></editCompany>
                  <editControlRange
                    v-else-if="detail.type == 'controlArea'"
                    :detail="detail"
                    :tableData="tableData"
                    @getData="getData"
                    @setLoading="setLoading"
                    :receiptClaimModeList="receiptClaimModeList"
                    ref="editControlRange"
                  ></editControlRange>
                  <editDepartment
                    v-else
                    :detail="detail"
                    :tableData="tableData"
                    :unitData="unitData"
                    @getData="getData"
                    :receiptClaimModeList="receiptClaimModeList"
                    @setLoading="setLoading"
                    ref="editDepartment"
                  ></editDepartment>
                </div>
                <!--底部操作按钮-->
                <div class="footer" v-if="edit">
                  <el-button :loading="load" @click="updateSure()" type="primary">{{
                    $t('dialog.confirm')
                  }}</el-button>
                  <el-button @click="edit = false">{{ $t('dialog.cancel') }}</el-button>
                </div>
              </el-tab-pane>
              <!-- <el-tab-pane :label="$t('company.system')" name="second">系统映射表</el-tab-pane> -->
              <el-tab-pane :label="$t('company.history')" name="third">
                <div class="detail">
                  <historyData ref="historyData"></historyData>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <!--普通账号-->
          <div v-if="userInfo.userInfo.adminFlag == 2">
            <el-tabs type="card" v-model="activeName" class="common-tab">
              <!-- <el-tab-pane :label="firstLabel" name="first">
                <div class="detail">
                  <companyDetail
                    v-if="detail.type == 'company'"
                    :detail="detail"
                    :tableData="tableData"
                    ref="companyDetail"
                  ></companyDetail>
                  <controlRangeDetail
                    v-else-if="detail.type == 'controlArea'"
                    :detail="detail"
                    :tableData="tableData"
                    ref="controlRangeDetail"
                  ></controlRangeDetail>
                  <departmentDetail
                    v-else
                    :detail="detail"
                    :tableData="tableData"
                    :unitData="unitData"
                    ref="departmentDetail"
                  ></departmentDetail>
                </div>
              </el-tab-pane> -->
              <el-tab-pane :label="$t('company.history')" name="third">
                <div class="detail">
                  <historyData ref="historyData"></historyData>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <addCompany
      v-on:getData="getData"
      :receiptClaimModeList="receiptClaimModeList"
      ref="addCompany"
    ></addCompany>
    <addControl
      v-on:getData="getData"
      :receiptClaimModeList="receiptClaimModeList"
      ref="addControl"
    ></addControl>
    <addDepartment
      v-on:getData="getData"
      :receiptClaimModeList="receiptClaimModeList"
      :tableData="tableData"
      ref="addDepartment"
    ></addDepartment>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/masterData/company.js';
  import SiruiSearch from '@/components/SiruiSearch';
  // import SiruiTable from '@/components/SiruiTable';
  import companyDetail from '../components/detail/companyDetail';
  import departmentDetail from '../components/detail/departmentDetail';
  import controlRangeDetail from '../components/detail/controlRangeDetail';
  import addCompany from '../components/addModal/addCompany';
  import addControl from '../components/addModal/addControl';
  import addDepartment from '../components/addModal/addDepartment';
  import editCompany from '../components/edit/editCompany';
  import editDepartment from '../components/edit/editDepartment';
  import editControlRange from '../components/edit/editControlRange';
  import historyData from '../components/detail/historyData';

  export default {
    name: 'department',
    components: {
      SiruiSearch,
      // SiruiTable,
      companyDetail,
      departmentDetail,
      controlRangeDetail,
      addCompany,
      addControl,
      addDepartment,
      editCompany,
      editDepartment,
      editControlRange,
      historyData,
    },
    data() {
      return {
        activeName: 'first',
        query: {
          createDepartmentName: null,
          createDepartmentCode: null,
          organization: '1',
          currentStatus: null,
        },
        data: [],
        defaultProps: {
          children: 'children',
          label: function (data) {
            return data.label;
          },
        },
        detail: {},
        menuButtonList: [],
        tableData: [],
        unitData: [],
        load: false,
        edit: false,
        //历史记录的类型
        historyData: [],
        level: 0,
        organizationList: [
          {
            label: '公司-部门',
            value: '1',
          },
          {
            label: '控制范围-部门',
            value: '0',
          },
        ],
        statusList: [
          {
            label: '已禁用',
            value: '1',
          },
          {
            label: '已生效',
            value: '0',
          },
        ],
      };
    },
    computed: {
      firstLabel: {
        get: function () {
          if ('company' == this.detail.type) {
            return this.$t('company.companyInfo');
          } else if ('controlArea' == this.detail.type) {
            return this.$t('company.controlRangeInfo');
          } else {
            return this.$t('company.departmentInfo');
          }
        },
      },
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'createDepartmentName',
            name: this.$t('department.search.departmentName'),
            type: 'input',
            placeholder: this.$t('department.search.departmentNamePlaceholder'),
          },
          {
            prop: 'createDepartmentCode',
            name: this.$t('department.search.departmentCode'),
            type: 'input',
            placeholder: this.$t('department.search.departmentCodePlaceholder'),
          },
          {
            prop: 'organization',
            name: this.$t('department.search.organization'),
            type: 'select',
            placeholder: this.$t('department.search.organizationPlaceholder'),
            clearable: false,
            options: this.organizationList,
          },
          {
            prop: 'currentStatus',
            name: this.$t('company.search.status'),
            type: 'select',
            placeholder: this.$t('company.search.statusPlaceholder'),
            clearable: true,
            options: this.statusList,
          },
        ];
      },
      heightTree() {
        return window.innerHeight - 265 + 'px';
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
        receiptClaimModeList() {
          return this.$baseRequest.getDictListByType('receiveClaimPattern');
        },
      }),
    },
    mounted() {
      this.$nextTick(() => {
        this.getButtonList();
        this.getData();

        if (this.userInfo.userInfo.adminFlag == 2) this.activeName = 'third';
      });
    },
    methods: {
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      getData() {
        this.data = [];
        this.detail = {};
        this.historyData = [];
        this.load = false;
        this.edit = false;
        this.tableData = [];
        this.unitData = [];
        const query = this.$refs.siruiSearch.query;
        query.tenantCode = this.userInfo.userInfo.tenantCode;
        query.adminFlag = this.userInfo.userInfo.adminFlag;
        query.departmentFlag = 1;
        if (this.$route.params.name) {
          query.createDepartmentName = this.$route.params.name;
        }
        let API_TREE = API.LIST_COMPANY_API;
        //查询控制范围-部门树
        if (query.organization == '0') {
          API_TREE = API.GET_CONTROL_LIST_API;
        } else {
          API_TREE = API.LIST_COMPANY_API;
        }
        this.$axios.post(API_TREE, query).then((res) => {
          if (0 == res.data.code) {
            this.data = res.data.data;
            if (query.currentStatus) {
              this.$nextTick(() => {
                this.$refs.tree.filter(query.currentStatus);
              });
            }
            if (query.createDepartmentName) {
              this.$nextTick(() => {
                this.$refs.tree.filter(query.createDepartmentName);
              });
            }
            if (query.createDepartmentCode) {
              this.$nextTick(() => {
                this.$refs.tree.filter(query.createDepartmentCode);
              });
            }
            if (this.$route.query.createDepartmentCode && this.userInfo.userInfo.adminFlag == 1) {
              //设置默认选中
              this.$nextTick(() => {
                this.$refs.tree.setCurrentKey(this.$route.query.createDepartmentCode);
                //调用查询详情的方法
                this.handleNodeClick(this.$refs.tree.getCurrentNode());
              });
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      filterNode(value, data) {
        if (!value) return true;
        if (this.query.createDepartmentName) {
          return data.attributes.createDepartmentName
            ? data.attributes.createDepartmentName.indexOf(value) !== -1
            : false;
        }
        if (this.query.currentStatus) {
          return data.attributes.currentStatus
            ? data.attributes.currentStatus.indexOf(value) !== -1
            : false;
        }
        if (this.query.createDepartmentCode) {
          return data.attributes.createDepartmentCode
            ? data.attributes.createDepartmentCode.indexOf(value) !== -1
            : false;
        }
      },
      //搜索
      searchBtnClick() {
        this.getData();
        if (this.query.createDepartmentName) {
          this.$refs.tree.filter(this.query.createDepartmentName);
        }
        if (this.query.currentStatus) {
          this.$refs.tree.filter(this.query.currentStatus);
        }
        if (this.query.createDepartmentCode) {
          this.$refs.tree.filter(this.query.createDepartmentCode);
        }
      },
      //重置
      resetBtnClick() {
        this.getData();
      },
      chooseClick(type) {
        if (type == 'add') {
          this.addDepartment();
        } else if (type == 'edit') {
          this.editDepartment();
        } else if (type == 'forbid') {
          this.fotbidDepartment();
        } else if (type == 'lift') {
          this.liftDepartment();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('error.clickError'),
            type: 'error',
          });
        }
      },
      //新增部门
      addDepartment() {
        if (JSON.stringify(this.detail) == '{}') {
          if (this.$refs.siruiSearch.query.organization == '1') {
            //新增公司
            this.$refs.addCompany.openDialog(true, this.detail);
          } else {
            //新增控制范围
            this.$refs.addControl.openDialog(true);
          }
        } else if (this.detail.type == 'company') {
          this.tableData = [];
          //新增部门
          this.detail.superiorUnitCode = this.detail.createCompanyCode;
          this.detail.superiorUnit = this.detail.createCompanyName;
          this.$refs.addDepartment.openDialog(true, this.detail);
        } else if (this.detail.type == 'department') {
          if (this.level > 4) {
            this.$message({
              showClose: true,
              message: this.$t('company.addError'),
              type: 'error',
            });
            return;
          }
          this.tableData = [];
          //新增部门
          this.detail.superiorUnitCode = this.detail.createDepartmentCode;
          this.detail.superiorUnit = this.detail.createDepartmentName;
          this.$refs.addDepartment.openDialog(true, this.detail);
        } else {
          //新增部门
          this.detail.superiorUnitCode = null;
          this.detail.superiorUnit = null;
          this.tableData = [
            {
              controlAreaCode: this.detail.controlAreaCode,
              controlAreaName: this.detail.controlAreaName,
            },
          ];
          this.$refs.addDepartment.openDialog(true, this.detail);
        }
      },
      //编辑部门
      editDepartment() {
        if (JSON.stringify(this.detail) == '{}') {
          this.$message({
            showClose: true,
            message: this.$t('company.editTips'),
            type: 'error',
          });
          return;
        }
        this.edit = true;
        this.activeName = 'first';
        if (this.detail.type == 'department') {
          this.$nextTick(() => {
            this.$refs.editDepartment.initData();
          });
        } else if (this.detail.type == 'company') {
          this.$nextTick(() => {
            this.$refs.editCompany.initData();
          });
        } else {
          this.$nextTick(() => {
            this.$refs.editControlRange.initDepartment();
          });
        }
      },
      //禁用部门
      fotbidDepartment() {
        if (JSON.stringify(this.detail) == '{}') {
          this.$message({
            showClose: true,
            message: this.$t('company.fotbidNoTips'),
            type: 'error',
          });
          return;
        }
        if (this.detail.currentStatus == '1') {
          this.$message({
            showClose: true,
            message: this.$t('company.fotbidTips'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction(this.$t('confirm.forbid'), this.$t('confirm.forbidContent'))
          .then(() => {
            const params = {
              currentStatus: '1',
              version: this.detail.version,
            };
            this.loading.startLoading();
            let API_STATUS = '';
            if (this.detail.type == 'controlArea') {
              params.controlAreaCode = this.detail.controlAreaCode;
              API_STATUS = API.UPDATE_CONTROL_STATUS_API;
            } else if (this.detail.type == 'department') {
              params.createDepartmentCode = this.detail.createDepartmentCode;
              params.belongCompanyCode = this.detail.belongCompanyCode;
              API_STATUS = API.UPDATE_DEPART_STATUS_API;
            } else {
              params.createCompanyCode = this.detail.createCompanyCode;
              API_STATUS = API.UPDATE_STATUS_API;
            }
            this.$axios.post(API_STATUS, params).then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                this.getData();
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //启用部门
      liftDepartment() {
        if (JSON.stringify(this.detail) == '{}') {
          this.$message({
            showClose: true,
            message: this.$t('company.liftNoTips'),
            type: 'error',
          });
          return;
        }
        if (this.detail.currentStatus == '0') {
          this.$message({
            showClose: true,
            message: this.$t('company.liftTips'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction(this.$t('confirm.lift'), this.$t('confirm.liftContent'))
          .then(() => {
            const params = {
              currentStatus: '0',
              version: this.detail.version,
            };
            let API_STATUS = '';
            if (this.detail.type == 'controlArea') {
              params.controlAreaCode = this.detail.controlAreaCode;
              API_STATUS = API.UPDATE_CONTROL_STATUS_API;
            } else if (this.detail.type == 'department') {
              params.createDepartmentCode = this.detail.createDepartmentCode;
              params.belongCompanyCode = this.detail.belongCompanyCode;
              API_STATUS = API.UPDATE_DEPART_STATUS_API;
            } else {
              params.createCompanyCode = this.detail.createCompanyCode;
              API_STATUS = API.UPDATE_STATUS_API;
            }
            this.loading.startLoading();
            this.$axios.post(API_STATUS, params).then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                this.getData();
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //选择公司或部门
      handleNodeClick(data, node) {
        this.level = node.level;
        this.unitData = [];
        this.edit = false;
        let API_DETAIL = '';
        if (data.type == 'company') {
          //公司详情
          API_DETAIL = API.GET_COMPANY_DETAIL_API;
        } else if (data.type == 'controlArea') {
          //控制范围详情
          API_DETAIL = API.GET_CONTROL_AREA_API;
        } else {
          //部门详情
          API_DETAIL = API.GET_DEPARTMENT_DETAIL_API;
        }
        //管理员可以查看详情
        if (this.userInfo.userInfo.adminFlag == 1) {
          this.$axios.get(API_DETAIL + '/' + data.id).then((res) => {
            if (0 == res.data.code) {
              if (data.type == 'company') {
                //历史记录
                this.getHistoryData('company', res.data.data.company.createCompanyCode);
                //公司详情
                this.detail = res.data.data.company;
                this.detail.type = data.type;
                this.detail.currentStatusName =
                  res.data.data.company.currentStatus == '0' ? '已生效' : '已禁用';
                this.tableData = res.data.data.department;
              } else if (data.type == 'controlArea') {
                //历史记录
                this.getHistoryData('controlArea', res.data.data.controlArea.controlAreaCode);
                //控制范围详情
                this.detail = res.data.data.controlArea;
                this.detail.type = data.type;
                this.detail.currentStatusName =
                  res.data.data.controlArea.currentStatus == '0' ? '已生效' : '已禁用';
                //关联部门
                this.tableData = res.data.data.departmentList;
              } else {
                //历史记录
                this.getHistoryData(
                  'department',
                  res.data.data.departmentDetail.createDepartmentCode
                );
                //部门详情
                this.detail = res.data.data.departmentDetail;
                this.detail.type = data.type;
                this.detail.currentStatusName =
                  res.data.data.departmentDetail.currentStatus == '0' ? '已生效' : '已禁用';
                //上级单位
                this.unitData = [res.data.data.company || res.data.data.department];
                this.unitData[0].superiorUnitCode = res.data.data.company
                  ? res.data.data.company.createCompanyCode
                  : res.data.data.department.createDepartmentCode;
                //所属控制范围
                this.tableData = res.data.data.controlAreaList;
              }
            } else {
              this.$alert(res.data.msg);
            }
          });
        } else {
          this.detail.type = data.type;
          if (data.type == 'company') {
            //历史记录
            this.getHistoryData('company', data.id);
          } else if (data.type == 'controlArea') {
            //历史记录
            this.getHistoryData('controlArea', data.id);
          } else {
            //历史记录
            this.getHistoryData('department', data.id);
          }
        }
      },
      getHistoryData(type, code) {
        this.$refs.historyData.getData(type, code);
      },
      setLoading(obj) {
        this.load = obj.loading;
        if (obj.edit) {
          this.edit = obj.edit;
        }
      },
      //修改保存
      updateSure() {
        if (this.detail.type == 'department') {
          this.$refs.editDepartment.addSure(this.load);
        } else if (this.detail.type == 'company') {
          this.$refs.editCompany.addSure(this.load);
        } else {
          this.$refs.editControlRange.addSure(this.load);
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .department-content {
    margin-top: 10px;
  }
  .i-icon {
    float: right;
    i {
      cursor: pointer;
      margin: 0 2px;
    }
  }
  .footer {
    background: #fff;
    height: 70px;
    line-height: 70px;
    text-align: center;
    margin-top: 10px;
  }
</style>
